import ApiService from "../api";

export default class ConfiguracaoAprovacaoFilialService extends ApiService {

    constructor() {
        super('/api/solicitacoes/config/filial-aprovacao')
    }

    listarPorProcesso(tipoProcesso) {
        return this.get(`?tipoProcesso=${tipoProcesso}`)
    }

    cadastrar(dados) {
        return this.post(``, dados)
    }

    atualizar(id, dados) {
        return this.put(`/${id}`, dados)
    }

    excluir(id) {
        return this.delete(`/${id}`)
    }
}
